var _LinkWidgetDescriptor_domElem, _LinkWidgetDescriptor_view, _LinkWidgetDescriptor_getPos;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import React from 'react';
import { LinkAttr, linkType, normalizeUrlFactory } from '../../../../extensions/markdown';
import { removeDecoration } from '../../WidgetDecoration';
import { ReactWidgetDescriptor } from '../../WidgetDecoration/ReactWidgetDescriptor';
import { LinkPlaceholderWidget } from './widget';
export const addPlaceholder = (tr, deps) => {
    return new LinkWidgetDescriptor(tr.selection.from, deps).applyTo(tr);
};
export class LinkWidgetDescriptor extends ReactWidgetDescriptor {
    constructor(initPos, deps) {
        super(initPos, 'link-empty');
        _LinkWidgetDescriptor_domElem.set(this, void 0);
        _LinkWidgetDescriptor_view.set(this, void 0);
        _LinkWidgetDescriptor_getPos.set(this, void 0);
        this.onCancel = () => {
            if (!__classPrivateFieldGet(this, _LinkWidgetDescriptor_view, "f"))
                return;
            __classPrivateFieldGet(this, _LinkWidgetDescriptor_view, "f").dispatch(removeDecoration(__classPrivateFieldGet(this, _LinkWidgetDescriptor_view, "f").state.tr, this.id));
            __classPrivateFieldGet(this, _LinkWidgetDescriptor_view, "f").focus();
        };
        this.onSubmit = (params) => {
            const normalizeResult = this.normalizeUrl(params.url);
            if (!normalizeResult || !__classPrivateFieldGet(this, _LinkWidgetDescriptor_view, "f") || !__classPrivateFieldGet(this, _LinkWidgetDescriptor_getPos, "f"))
                return;
            const { url } = normalizeResult;
            const text = params.text.trim() || normalizeResult.text;
            const from = __classPrivateFieldGet(this, _LinkWidgetDescriptor_getPos, "f").call(this);
            const to = from + text.length;
            let tr = __classPrivateFieldGet(this, _LinkWidgetDescriptor_view, "f").state.tr;
            tr = tr.insertText(text, from);
            tr = tr.addMark(from, to, linkType(__classPrivateFieldGet(this, _LinkWidgetDescriptor_view, "f").state.schema).create({ [LinkAttr.Href]: url }));
            tr = removeDecoration(tr, this.id);
            __classPrivateFieldGet(this, _LinkWidgetDescriptor_view, "f").dispatch(tr);
            __classPrivateFieldGet(this, _LinkWidgetDescriptor_view, "f").focus();
        };
        __classPrivateFieldSet(this, _LinkWidgetDescriptor_domElem, document.createElement('span'), "f");
        this.normalizeUrl = normalizeUrlFactory(deps);
    }
    getDomElem() {
        return __classPrivateFieldGet(this, _LinkWidgetDescriptor_domElem, "f");
    }
    renderReactElement(view, getPos) {
        __classPrivateFieldSet(this, _LinkWidgetDescriptor_view, view, "f");
        __classPrivateFieldSet(this, _LinkWidgetDescriptor_getPos, getPos, "f");
        return React.createElement(LinkPlaceholderWidget, { onCancel: this.onCancel, onSubmit: this.onSubmit });
    }
}
_LinkWidgetDescriptor_domElem = new WeakMap(), _LinkWidgetDescriptor_view = new WeakMap(), _LinkWidgetDescriptor_getPos = new WeakMap();
